import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['submitButton']

  toggleAcceptance(e) {
    this.submitButtonTarget.disabled = !e.target.checked
  }
}
